import React from "react";

const Logo = () => {
  return (
    <div className="share__logo">
      <svg
        className="share__logo--background"
        width="88"
        height="89"
        viewBox="0 0 88 89"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M53.876 1.787C27.21-3.773 6.12 13.81 1.278 35.857-3.564 57.9 8.986 82.36 32.878 87.344c23.896 4.982 47.75-10.95 53.968-39.266 6.22-28.318-21.278-43.855-32.97-46.293"
          fill="#37455A"
          fillRule="evenodd"
        />
      </svg>
      <svg
        className="share__logo--logo"
        width="88"
        height="88"
        viewBox="0 0 55 55"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M24.155 44.9c-2.237 0-.776-6.84 2.68-11.788-.448 6.245-1.248 11.79-2.68 11.79zM3.645 28.1c0-.117.007-.232.01-.348 1.685-.378 4.264-1.11 6.885-1.898.05 4.75.403 9.406.403 11.372h2.797s-.388-6.218-.394-12.227c2.46-.763 4.655-1.468 5.807-1.84-.658 4.644-.878 10.61 2.34 10.61 2.874 0 4.686-4.487 5.74-8.562-.063 1.88-.15 3.888-.268 5.88-5.01 5.687-7.295 15.567-2.642 15.567 3.626 0 5.084-8.747 5.654-16.922 1.162-.88 2.432-1.458 3.78-1.586-.218 7.275-.473 15.532-.473 15.532h3.05c0-.716.075-4.088.17-8.19.272.108.6.178 1.003.178 2.374 0 4.29-1.758 5.613-4.133 2.945-1.007 6.375-2.387 7.888-3.007 0 .05.003.097.003.147 0 14.366-18.508 23.257-27.36 23.257-7.883 0-20.164-10.364-20.006-23.832zm34.397 6.245c-1.286 0-1.35-.29-1.35-.576 0-.54.193-1.057 1.896-1.057.23 0 .533-.04.894-.112-.526 1.06-1.034 1.745-1.44 1.745zm-1.452-2.443l.112-4.588c1.015-2.984 3.247-6.822 5.19-6.822 1.302 0-.14 6.553-1.766 10.644-.825.224-1.493.358-1.897.358-.74 0-1.254.163-1.64.408zm14.378-5.043c-1.39.794-4.32 2.043-7.07 3.046 1.98-4.856 1.755-11.016-1.617-11.016-2.616 0-4.556 3.448-5.51 5.59.1-4.044.18-7.113.18-7.113h-2.894c0 .54-.124 4.85-.27 9.83-1.297.062-2.55.5-3.724 1.217.393-6.655.233-12.58.233-12.58h-2.893s0 1.176-.024 3.04c-.006.034-2.28 12.143-4.715 12.143-2.44 0 .334-13.243.334-13.243H20.17s-.31 1.26-.642 3.07c-.99.91-3.41 1.82-6.176 2.627.056-5.032.436-9.517 1.616-9.517.975 0 1.225 2.93 1.225 2.93h.955s.16-4.405-3.28-4.405c-2.64 0-3.296 5.714-3.332 11.755-2.505.63-4.997 1.156-6.784 1.51C4.736 13.332 12.387 3.25 26.694 3.25c16.785 0 23.71 10.23 24.274 23.61zM.64 21.89c-3.018 13.747 4.807 29 19.706 32.107 14.9 3.107 29.774-6.828 33.652-24.485S40.73 2.167 33.438.647C16.812-2.82 3.66 8.143.642 21.89z"
          fill="#ffffff"
          fillRule="evenodd"
        />
      </svg>
    </div>
  );
};

export default Logo;
